import { render, staticRenderFns } from "./NumberRange.vue?vue&type=template&id=2945db07&scoped=true&"
import script from "./NumberRange.vue?vue&type=script&lang=js&"
export * from "./NumberRange.vue?vue&type=script&lang=js&"
import style0 from "./NumberRange.vue?vue&type=style&index=0&id=2945db07&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2945db07",
  null
  
)

export default component.exports